import { Box, Chip } from "@material-ui/core";
import { G, D } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import * as React from "react";
import { useFilters } from "./utils";

function flattenCategories(categories, path = []) {
  if (!categories) {
    return [];
  }

  return Object.values(categories).flatMap((category) => {
    const newPath = path.concat(category.id);
    const item = {
      id: category.id,
      name: category.name,
      path: newPath,
    };

    return Array.isArray(category.subcategories) &&
      category.subcategories.length > 0
      ? [item, ...flattenCategories(category.subcategories, newPath)]
      : [item];
  });
}

function flattenFilterCategories(categories, resultSet = new Set()) {
  if (D.isEmpty(categories) || G.isBoolean(categories)) {
    return resultSet;
  }

  Object.entries(categories).forEach(([key, value]) => {
    resultSet.add(Number(key));
    flattenFilterCategories(value, resultSet);
  });

  return resultSet;
}

function deepDelete(path) {
  return (obj) => {
    if (D.isEmpty(obj)) {
      return obj;
    }

    const [key, ...rest] = path;

    if (rest.length === 0) {
      return D.deleteKey(obj, key);
    }

    const value = obj[key];

    if (G.isObject(value)) {
      const [first] = rest;

      if (D.values(value).length === 1 && value[first]) {
        return D.deleteKey(obj, key);
      }

      return {
        ...obj,
        [key]: deepDelete(rest)(value),
      };
    }

    return obj;
  };
}

export default function SelectedCategories({ filter, setFilter }) {
  const { filters } = useFilters();

  const flattenedCategories = React.useMemo(() => {
    return flattenCategories(Object.values(filters.category));
  }, [filters]);

  const flattenedFilterCategories = React.useMemo(() => {
    return flattenFilterCategories(filter.category);
  }, [filter.category]);

  return (
    <Box display="flex" flexWrap="wrap" gridGap="8px">
      {flattenedCategories.reduce((result, { id, name, path }) => {
        const found = flattenedFilterCategories.has(id);

        if (!found) {
          return result;
        }

        result.push(
          <Chip
            key={id}
            label={name}
            onDelete={() => {
              setFilter(D.update("category", deepDelete(path)));
            }}
          />,
        );

        return result;
      }, [])}
    </Box>
  );
}

SelectedCategories.propTypes = {
  filter: PropTypes.shape({
    category: PropTypes.object,
  }),
  setFilter: PropTypes.func.isRequired,
};
